function initLogin(arg) {
	if (document.querySelector('[data-login="container"]') != null) {
		const container = document.querySelector('[data-login="container"]')

		const openNoticeLink = document.querySelectorAll(
			'[data-login="open-notice-link"]'
		)
		// const getCode = container.querySelector('[data-login="get-code"]')
		// const enterCode = container.querySelector('[data-login="enter-code"]')
		const enterPassword = container.querySelector(
			'[data-login="enter-password"]'
		)
		// const enterPasswordLink = container.querySelectorAll('[data-login="enter-password-link"]')
		const enterSmsLink = container.querySelector(
			'[data-login="enter-sms-link"]'
		)
		const getCodeBtn = container.querySelector('[data-login="get-code-btn"]')
		const show = elem => elem.classList.add('show')
		const hide = elem => elem.classList.remove('show')
		const showEnterPassword = () => {
			hide(getCode)
			hide(enterCode)
			show(enterPassword)
		}
		const showEnterSmsLink = () => {
			hide(getCode)
			show(enterCode)
			hide(enterPassword)
		}
		const showGetCodeBtn = () => {
			hide(getCode)
			show(enterCode)
			hide(enterPassword)
		}
		openNoticeLink.forEach(el => {
			el.onclick = () => {
				// hide(getCode)
				// hide(enterCode)
				show(enterPassword)
			}
		})

		// enterPasswordLink.forEach(item => {
		// 	item.addEventListener('click', () => {
		// 		showEnterPassword()
		// 	})
		// })
		// enterSmsLink.addEventListener('click', () => {
		// 	showEnterSmsLink()
		// })
		// getCodeBtn.addEventListener('click', () => {
		// 	showGetCodeBtn()
		// })
		document.addEventListener('click', event => {
			if (
				!event.target.closest('[data-login="container"]') &&
				!event.target.closest('[data-login="open-notice-link"]')
			) {
				// hide(getCode)
				// hide(enterCode)
				hide(enterPassword)
			}
		})
	}
}
function openAuth() {
	if (document.querySelector('.user-auth') != null) {
		const btn = document.querySelector('.user-auth')

		btn.onclick = () => {
			btn.classList.toggle('user-auth-open')

			const userOpen = document.querySelector('.user-auth-open')
			const list = document.querySelector('.mg-avatar__list')

			if (userOpen) {
				list.setAttribute('style', 'visibility: visible; opacity: 1;')
			} else {
				list.removeAttribute('style')
			}
		}
	}
}
